module.exports = __webpack_public_path__ + "static/media/point1.80c1b014.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/point1.png
// module id = 458
// module chunks = 0